// v1.29.0 — Raporlar sayfası: raporların tek listesi. Görünürlük her raporun modül yetkisine bağlıdır.
export interface RaporTanim {
  id: string;
  baslik: string;
  aciklama: string;
  yol: string;
  modul: string;
  ikon: string;
}

export interface RaporKategori {
  id: string;
  baslik: string;
  ikon: string;
  renk: string;
  raporlar: RaporTanim[];
}

export const RAPOR_MERKEZI_YOLU = '/rapor-merkezi';

export const RAPOR_KATEGORILERI: RaporKategori[] = [
  {
    id: 'proje',
    baslik: 'Proje ve Satış',
    ikon: 'fas fa-building',
    renk: '#cd6906',
    raporlar: [
      { id: 'proje-ozeti', baslik: 'Proje Özeti', aciklama: 'Projelerin daire durumu ve tutar dağılımı', yol: '/ozet', modul: 'Projeler', ikon: 'fas fa-chart-pie' },
      { id: 'proje-raporlari', baslik: 'Proje Raporları', aciklama: 'Stok, satış hızı ve personel performansı analizleri', yol: '/proje-raporlari', modul: 'Projeler', ikon: 'fas fa-chart-line' },
      { id: 'sunum-teklif', baslik: 'Sunum Teklif Raporları', aciklama: 'Tarih, proje ve daire bazlı sunum istatistikleri', yol: '/musteri-sunumlari?rapor=1', modul: 'Projeler', ikon: 'fas fa-chalkboard-teacher' },
    ],
  },
  {
    id: 'musteri',
    baslik: 'Müşteri',
    ikon: 'fas fa-users',
    renk: '#2563eb',
    raporlar: [
      { id: 'musteri', baslik: 'Müşteri Raporu', aciklama: 'Filtrelerle müşteri kayıtlarını sorgulama ve toplu işlem', yol: '/musteriler-raporu', modul: 'MusteriBilgileri', ikon: 'fas fa-user-check' },
      { id: 'potansiyel-musteri', baslik: 'Potansiyel Müşteri Raporu', aciklama: 'Dönem bazlı yeni kayıtlar ve görüşme aktiviteleri', yol: '/lead-takip?rapor=1', modul: 'PotansiyelMusteri', ikon: 'fas fa-headset' },
    ],
  },
  {
    id: 'emlak',
    baslik: 'Emlak',
    ikon: 'fas fa-home',
    renk: '#7c3aed',
    raporlar: [
      { id: 'emlak', baslik: 'Emlak Raporları', aciklama: 'Portföy, sunum ve satış verilerinin özet analizi', yol: '/emlak-rapor', modul: 'Emlak', ikon: 'fas fa-chart-bar' },
    ],
  },
  {
    id: 'finans',
    baslik: 'Finans',
    ikon: 'fas fa-coins',
    renk: '#16a34a',
    raporlar: [
      { id: 'finansal-ozet', baslik: 'Finansal Özet', aciklama: 'Kasaların ve mali durumun anlık görünümü', yol: '/finansal-ozet', modul: 'FinansalIslemler', ikon: 'fas fa-wallet' },
      { id: 'finansal-raporlar', baslik: 'Finansal Raporlar', aciklama: 'Gelir-gider, cari ve kasa ekstreleri, nakit akışı, tahsilat', yol: '/raporlar', modul: 'FinansalIslemler', ikon: 'fas fa-file-invoice' },
    ],
  },
];

// Menüde Raporlar'ı seçili gösteren sayfalar (raporların alt sayfaları dahil)
const RAPOR_SAYFALARI = [
  RAPOR_MERKEZI_YOLU, '/ozet', '/proje-raporlari', '/stok-erime-hizi', '/stok-bekleme', '/personel-performans-raporu',
  '/musteriler-raporu', '/emlak-rapor', '/finansal-ozet', '/raporlar', '/hesap-hareketleri-raporu', '/envanter-raporu',
  '/nakit-akis-proj', '/tahsilat-performans',
];

export const raporSayfasiMi = (pathname: string, search: string): boolean =>
  RAPOR_SAYFALARI.includes(pathname) || new URLSearchParams(search).get('rapor') === '1';

export const raporKategorileri = (hasPermission: (modul: string) => boolean): RaporKategori[] =>
  RAPOR_KATEGORILERI
    .map(k => ({ ...k, raporlar: k.raporlar.filter(r => hasPermission(r.modul)) }))
    .filter(k => k.raporlar.length > 0);
